import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("95da41dd7a", ".c2b489ab9a172a81__leaf{font-weight:var(--wpds-typography-font-weight-default,400)}span.c2b489ab9a172a81__leaf a[href]{align-items:center;display:inline-flex}");
}
export default {"leaf":"c2b489ab9a172a81__leaf"};
